import { Carousel } from 'antd';
import { CarouselRef } from 'antd/lib/carousel';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import classnames from 'classnames';
import { RevxCircleLabel } from 'components/RevxCircleLabel';
import { BUSINESS_TYPE_ENUM } from 'domains/gallerySkuDomain';
import { useMemo, useRef } from 'react';
import { useHistory } from 'react-router';
import { startJobConfigWithGalleryLabel } from 'utils/gallery';
import './BusinessTypeGallerySlick.less';

export type Props = {
  businessType: BUSINESS_TYPE_ENUM;
  className?: string;
};

const carouselPageSize = 8;
const settings = {
  infinite: false,
  speed: 300,
  slidesToShow: carouselPageSize,
  slidesToScroll: 1,
};

export const BusinessTypeGallerySlick = (props: Props) => {
  const dispatch = useAppDispatch();
  const allGalleryLabels = useAppSelector(
    (state) => state.gallery.galleryLabels
  );

  const businessTypeGalleryLabels = useMemo(() => {
    return allGalleryLabels.filter((item) => {
      return (
        item.skuLabel.businessTypes.includes(props.businessType) &&
        item.skuCount > 0 &&
        item.skuLabel.active &&
        !item.skuLabel.parentId &&
        !item.skuLabel.businessTypes.includes(BUSINESS_TYPE_ENUM.MY_COMPANY)
      );
    });
  }, [allGalleryLabels, props.businessType]);
  const carouselRef = useRef<CarouselRef>(null);

  const history = useHistory();

  return (
    <div className={classnames('business-type-gallery-slick', props.className)}>
      <div className="business-type-gallery-slick-line">
        <div
          className="business-type-gallery-slick-line-inner"
          style={{
            width: `calc(${
              Math.min(8, businessTypeGalleryLabels.length) * 150
            }px - 96px)`,
          }}
        ></div>
      </div>
      <div className="business-type-gallery-slick-list">
        <Carousel
          {...settings}
          dots={false}
          arrows={true}
          slidesToScroll={3}
          ref={carouselRef}
        >
          {businessTypeGalleryLabels.map((galleryLabel) => {
            return (
              <RevxCircleLabel
                text={String(galleryLabel.skuCount)}
                name={galleryLabel.skuLabel.name}
                key={galleryLabel.skuLabel.id}
                onChange={(checked) => {
                  if (checked) {
                    startJobConfigWithGalleryLabel(
                      dispatch,
                      galleryLabel,
                      history
                    );
                  }
                }}
              />
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};
